/**
 * AcceptInviteForm Component
 *
 * Form for entering and accepting an invite code
 */
import ButtonSpinner from '../Loading/ButtonSpinner';
import styles from './AcceptInviteForm.module.css';

function AcceptInviteForm({ inviteCode, setInviteCode, handleAccept, loading, error, onClose, handleKeyPress }) {
    return (
        <>
            {error && (
                <div className={styles.errorAlert}>
                    {error}
                </div>
            )}

            <div className={styles.formGroup}>
                <label className={styles.label}>
                    Invite Code
                </label>
                <input
                    type="text"
                    value={inviteCode}
                    onChange={(e) => setInviteCode(e.target.value.toUpperCase())}
                    onKeyPress={handleKeyPress}
                    placeholder="XXXX-XXXX"
                    maxLength={9}
                    className={styles.inviteInput}
                    autoFocus
                />
                <div className={styles.helpText}>
                    Enter the 8-character code (with or without dash)
                </div>
            </div>

            <div className={styles.infoBox}>
                <strong>Note:</strong> Accepting an invite will give you access to the budget based on the permissions set by the inviter.
            </div>

            <div className={styles.buttonContainer}>
                <button
                    onClick={onClose}
                    disabled={loading}
                    className={styles.cancelButton}
                >
                    Cancel
                </button>
                <button
                    onClick={handleAccept}
                    disabled={loading}
                    className={styles.submitButton}
                >
                    {loading && <ButtonSpinner />}
                    {loading ? 'Accepting...' : 'Accept Invite'}
                </button>
            </div>
        </>
    );
}

export default AcceptInviteForm;
